import { loadState } from "./storeState";

export function getAuthentication() {
	const state = loadState()
	let token = '';
	if (state) {
		token = state?.session?.token
	}
	return token
}

export function getOldAuthentication() {
	const state = loadState()
	let token = '';
	if (state) {
		token = state?.session?.old_token
	}
	return token
}

export function createAuthenticationCookie(resp) {
	let day = new Date();
	day.setTime(day.getTime() + (1 * 12 * 60 * 30 * 1000));
	let expires = "expires=" + day.toUTCString();
	document.cookie = "token-admin=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	document.cookie = "token-user=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	if (resp?.token_admin) {
		document.cookie = `token-admin=${resp.token_admin};${expires};path=/`;
	} else if (resp?.token_user) {
		document.cookie = `token-user=${resp?.token_user};${expires};path=/`;
	}
}

export function isAuthorized() {
	return document.cookie.includes('token-user') || document.cookie.includes('token-admin')
}

export function isAdmin() {
	return document.cookie.includes('token-admin');
}

export function cleanAuthorizationToken() {
	document.cookie = "token-admin=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	document.cookie = "token-user=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
}

const REDIRECT_AFTER_LOGIN_KEY = 'redirect_after_login';

/**
 * Guarda la ruta a la que se quería entrar sin sesión (p. ej. un enlace de un correo),
 * para llevar ahí al usuario en cuanto inicie sesión.
 */
export function saveRedirectAfterLogin(path) {
	if (!isSafeRedirect(path) || path === '/') return;
	try {
		sessionStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, path);
	} catch (error) {
		console.error('No se pudo guardar la ruta de retorno', error);
	}
}

/**
 * Devuelve la ruta guardada con `saveRedirectAfterLogin` y la borra, o null si no hay.
 */
export function takeRedirectAfterLogin() {
	try {
		const path = sessionStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
		sessionStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
		return isSafeRedirect(path) ? path : null;
	} catch (error) {
		return null;
	}
}

// Sólo rutas internas del panel: nada de `//otro-host` ni URLs absolutas.
function isSafeRedirect(path) {
	return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');
}

export function validatePermission(vCategory, vPermission, vAction) {
	let validate = false;
	const state = loadState()

	state?.session?.permissions?.forEach(({ category, name, action }) => {
		if (vCategory === category.toLowerCase() && vPermission === name.toLowerCase()) {
			let include = vAction.includes(action.toLowerCase())
			if (include)
				validate = true;
		}
	})
	return validate;
}